import { render, staticRenderFns } from "./SignUpDefault.vue?vue&type=template&id=af2cdc56"
import script from "./SignUpDefault.vue?vue&type=script&lang=js"
export * from "./SignUpDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports